import React, { useContext, useState } from "react"
import useSWR from "swr"
import Fade from "@material-ui/core/Fade"
import Box from "@material-ui/core/Box"
/** Service */
import UnitManagementAPI from "services/Dashboard/UnitManagement"
/** Components */
import Table from "components/Table"
import Loader from "components/Loader"
/** Context */
import { Context as CtxAccountRequest } from "context/Dashboard/UnitManagement/categories/accountsRequests/Context"
import { Context as ParentContext } from "context/Dashboard/UnitManagement/categories/main/Context"

import tableHeaders from "./table/tableHeaders"

const TableNew: React.FC = () => {
  const { setAccountRequestData } = useContext(CtxAccountRequest)
  const { showCreateFromData, setDownloadData } = useContext(ParentContext)
  const [currentPage, setCurrentPage] = useState(0)

  /** Methods */
  const fetchAccountRequests = async () =>
    UnitManagementAPI.getAccountRequests({
      "is_rejected": false
    })

  const { data, isValidating } = useSWR(
    "fetchAccountRequests",
    fetchAccountRequests,
    {
      revalidateOnFocus: true
    }
  )

  const tableData =
    data?.data?._data !== undefined && data?.data?._data !== null
      ? Object.values(data?.data?._data)
      : []

  const filteredData = tableData?.filter((i: any) => i.user_detail_public_uid === "")

  const createAccount = (activeData: Record<string, any>) => {
    setAccountRequestData && setAccountRequestData(activeData)
    showCreateFromData && showCreateFromData()
  }

  if (isValidating) {
    return (
      <Box height="500px">
        <Loader dark />
      </Box>
    )
  }

  return (
    <Fade in={!isValidating} timeout={1000}>
      <div>
        <Table
          data={filteredData}
          columns={tableHeaders(createAccount)}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          minRows={3}
          isFilterable
          action={(values: any) => {
            return (
              values.length !== 0 &&
              setDownloadData &&
              setDownloadData(
                values?.map((i: any) => {
                  return {
                    "Block/Unit No.": i?.unitNumber,
                    "Name": i?.name,
                    "Email": i?.email,
                    "Mobile": i?.mobileNumber
                  }
                })
              )
            )
          }}
        />
      </div>
    </Fade>
  )
}

export default TableNew
